export const widgetIconManifest = {
  GridChartWidget:              'th',
  FlipCardWidget:               'clone',
  CallProgressWidget:           'phone',
  PhaseProgressWidget:          'list-check',
  ReportStatusWidget:           'file-lines',
  ImageWidget:                  'image',
  EmbedWidget:                  'code',
  TableauWidget:                'chart-pie',
  PageEditorWidget:             'pen',
  EventFeedWidget:              'calendar-days',
  TitleWidget:                  'heading',
  WorkflowStatusWidget:         'sitemap',
  RiskGaugeWidget:              'triangle-exclamation',
  MapVisualisationWidget:       'globe',
  DataStripDatasetWidget:       'database',
  SimplePieDatasetWidget:       'chart-pie',
  DonutWithTargetDatasetWidget: 'bullseye',
  BarChartDatasetWidget:        'chart-bar',
  CumulativeLineDatasetWidget:  'chart-line',
  TimelineWidget:               'calendar-check',
  SDGTotalContributionWidget:   'leaf',
  AssignedTasksWidget:          'user-check',
  ApplicantProjectListWidget:   'folder-open',
  ApplicantReportListWidget:    'list',
  PaymentsWidget:               'credit-card',
  WorkflowDataStripWidget:      'share-nodes',
  ValuesAchievedDatasetWidget:  'trophy',
  TaskStatusWidget:             'circle-check',
  MapWidget:                    'location-dot',
  CustomChartWidget:            'palette',
  TabContainerWidget:           'table-columns',
  DiscussionWidget:             'comments',
  WorkflowStatusTrackerWidget:  'list-ul',
  GaugeWidget:                  'gauge-high',
  GridWidget:                   'table',
  AdvancedFilterWidget:         'sliders',
  ButtonFilterWidget:           'toggle-on',
  MyWorkWidget:                 'list-check',
  MyWorkQueuesWidget:           'layer-group',
};
